import { computed, makeAutoObservable, observable, runInAction } from 'mobx';
import { HTTP_STATUS_RESPONSE_KEY } from 'src/constants/api';
import { ResponseDTO } from 'src/dto/base.dto';
import {
	ActionOnAdminProposedDealDTO,
	GetMortgageDealPropertyDetailsDTO,
	SubmitCounterProposalDTO,
	SubmitInvestDealPropertyDTO
} from 'src/dto/mortgage-deal-details.dto';
import {
	IFunderLoanProposalItem,
	ILoanProposal,
	IMortgageInvestmentData,
	LoanProposalBiddingStatus
} from 'src/interfaces/mortgage-deal/mortgage-deal-details';
import { HttpService } from 'src/services/http.service';

export interface IMortgageInvestmentStore {
	dealDetail?: IMortgageInvestmentData;
	getMortgageDealPropertyDetails(id: string): Promise<void>;
	investDeal(propertyId: string, planId: string, mortgageId: string): Promise<boolean>;
	submitCounterProposal(propertyId: string, body: ILoanProposal, mortgageId: string): Promise<boolean>;
	get getMortgageBiddingProposal(): IFunderLoanProposalItem[];
	actionOnAdminProposal(propertyId: string, planId: string, mortgageId: string, isApprove: boolean): Promise<boolean>;
}

export class MortgageInvestmentStore implements IMortgageInvestmentStore {
	dealDetail?: IMortgageInvestmentData;
	constructor(private readonly http: HttpService) {
		makeAutoObservable(this, {
			dealDetail: observable,
			getMortgageBiddingProposal: computed
		});
	}
	public get getMortgageBiddingProposal(): IFunderLoanProposalItem[] {
		let rs: IFunderLoanProposalItem[] = [];
		if (this.dealDetail) {
			if (this.dealDetail.biddingLoanProposals && this.dealDetail.biddingLoanProposals.length) {
				rs = [...this.dealDetail.biddingLoanProposals];
			} else {
				rs = (this.dealDetail.loanProposals || []).map((e) => {
					return {
						biddingId: '',
						loanProposal: e,
						status: LoanProposalBiddingStatus.EmptyStatus
					};
				});
			}
		}

		return rs;
	}
	public async getMortgageDealPropertyDetails(id: string): Promise<void> {
		const dto = new GetMortgageDealPropertyDetailsDTO({
			id
		});

		const rs: ResponseDTO<IMortgageInvestmentData> = await this.http.request<
			GetMortgageDealPropertyDetailsDTO,
			IMortgageInvestmentData
		>(dto);

		if (rs.responseKey === HTTP_STATUS_RESPONSE_KEY.SUCCESS) {
			runInAction(() => {
				if (rs.data) {
					this.dealDetail = {
						...rs.data
					};
				}
			});
		}
	}

	public async actionOnAdminProposal(propertyId: string,planId: string, mortgageId: string, isApprove: boolean): Promise<boolean>{
		const dto = new ActionOnAdminProposedDealDTO({
			proposalId: planId,
			propertyId,
			mortgageId,
			isApprove
		});

		const rs: ResponseDTO<IFunderLoanProposalItem[]> = await this.http.request<ActionOnAdminProposedDealDTO, IFunderLoanProposalItem[]>(dto);

		if (rs.responseKey === HTTP_STATUS_RESPONSE_KEY.SUCCESS) {
			runInAction(()=>{
				if(rs.data && rs.data.length && this.dealDetail){
					this.dealDetail = {
						...this.dealDetail,
						biddingLoanProposals: [...rs.data]
					}
				}
			});
			return true;
		} else {
			return false;
		}
	}

	public async investDeal(propertyId: string, planId: string, mortgageId: string): Promise<boolean> {
		const dto = new SubmitInvestDealPropertyDTO({
			loanProposalId: planId,
			mortgageDealId: mortgageId,
			mortgagePropertyId: propertyId
		});

		const rs: ResponseDTO<IFunderLoanProposalItem[]> = await this.http.request<SubmitInvestDealPropertyDTO, IFunderLoanProposalItem[]>(dto);

		if (rs.responseKey === HTTP_STATUS_RESPONSE_KEY.SUCCESS) {
			runInAction(()=>{
				if(rs.data && rs.data.length && this.dealDetail){
					this.dealDetail = {
						...this.dealDetail,
						biddingLoanProposals: [...rs.data]
					}
				}
			});
			return true;
		} else {
			return false;
		}
	}

	public async submitCounterProposal(propertyId: string, body: ILoanProposal, mortgageId: string): Promise<boolean> {
		const dto = new SubmitCounterProposalDTO(
			{
				...body,
				mortgagePropertyId: propertyId,
				mortgageId
			}
		);

		const rs: ResponseDTO<IFunderLoanProposalItem[]> = await this.http.request(dto);

		if (rs.responseKey === HTTP_STATUS_RESPONSE_KEY.SUCCESS) {
			
			runInAction(
				()=>{
					if(this.dealDetail){
						this.dealDetail = {
							...this.dealDetail,
							biddingLoanProposals: rs.data || []
						}
					}
					
				}
			)
			return true;
		} else {
			return false;
		}
	}
}
